define('NMSDesignSystem.InitialContent.Shopping', ['CMSadapter.Landing.View', 'SC.CCT.Html.View', 'NMSDesignSystem.InitialHome.Shopping', 'Home.View'], function(LandingView, CmsHtmlView, InitialHome, HomeView) {
    'use strict';
    var ownClasses = ['nms-content-article', 'nms-content-duplicate-title', 'nms-content-breadcrumb'];
    var areaName = 'cms-landing-page-placeholder-page-type';
    function staticNodes(nodes) {
        var roots = InitialHome.inertNodes(nodes);
        var controls = 'button,[contenteditable],[role="button"],video,audio,canvas,details,summary,pre,code,svg,math';
        return roots && !roots.some(function(root) {
            if (root.matches(controls) || root.querySelector(controls)) return true;
            return [root].concat(Array.prototype.slice.call(root.querySelectorAll('[data-view],[data-cms-cct-instanceid]'))).some(function(node) {
                return node.hasAttribute('data-view') && node.getAttribute('data-view') !== 'CCT-View' ||
                    node.hasAttribute('data-cms-cct-instanceid') && !/^CMS_HTML-[0-9]+$/.test(node.getAttribute('data-cms-cct-instanceid'));
            });
        }) ? roots : null;
    }
    function cleanClasses(element, deep) {
        var copy = element.cloneNode(!!deep);
        [copy].concat(deep ? Array.prototype.slice.call(copy.querySelectorAll('*')) : []).forEach(function(node) {
            var changed = false;
            ownClasses.forEach(function(name) { if (node.classList.contains(name)) { node.classList.remove(name); changed = true; } });
            if (changed && node.getAttribute('class') === '') node.removeAttribute('class');
        });
        return copy;
    }
    function sameStaticPageContent(element, content) {
        if (!staticNodes(element.childNodes) || !staticNodes(content)) return false;
        var before = element.cloneNode(true), after = element.cloneNode(false);
        Array.prototype.forEach.call(content, function(node) { after.appendChild(node.cloneNode(true)); });
        var selector = '[data-cms-area="' + areaName + '"]';
        var oldAreas = before.querySelectorAll(selector), freshAreas = after.querySelectorAll(selector);
        if (oldAreas.length !== 1 || freshAreas.length !== 1 || !oldAreas[0].childElementCount ||
                !freshAreas[0].childElementCount || !staticNodes(oldAreas[0].childNodes) || !staticNodes(freshAreas[0].childNodes)) return false;
        function comparable(page) {
            var copy = cleanClasses(page, true);
            Array.prototype.slice.call(copy.childNodes).forEach(function(node) {
                if (node.nodeType === 8 && /^(TEMPLATE STARTS: cms_landing_page|TEMPLATE ENDS: cms_landing_page)$/.test(node.nodeValue.trim())) copy.removeChild(node);
            });
            return copy;
        }
        return comparable(before).isEqualNode(comparable(after));
    }
    function staticRoute(doc) {
        var host = window.location.hostname, route = window.location.pathname.replace(/\/$/, '') || '/';
        return ((host === 'nmsincusa.com' || host === 'sca-sandbox.ethanablatt.com') && ['/contact-us', '/shipping', '/returns'].indexOf(route) >= 0 ||
            (host === 'buyflushots.nmsincusa.com' || host === 'buyflu-sandbox.ethanablatt.com') && ['/contact-us', '/returns'].indexOf(route) >= 0) &&
            !!doc.querySelector('link[data-nms-critical-style][href*="-static-critical-"]');
    }
    function eligible(view) {
        var doc = typeof window !== 'undefined' && window.document;
        return !!(doc && typeof SC !== 'undefined' && SC.ENVIRONMENT && SC.ENVIRONMENT.jsEnvironment === 'browser' &&
            SC.isRehydrating === true && staticRoute(doc) && view.el && view.el.id === 'cms-landing-page' &&
            view.options && view.options.el === view.el && (!view.childViews || typeof view.childViews === 'object' && !Object.keys(view.childViews).length));
    }
    function normalText(text) {
        // HTML collapses only these ASCII spaces. NBSP and preformatted text stay exact.
        return text.replace(/[\t\n\f\r ]+/g, ' ');
    }
    function sameNormalNode(before, after, strict) {
        if (before.nodeType !== after.nodeType || before.nodeName !== after.nodeName) return false;
        if (before.nodeType === 3) {
            var normal = before.parentElement && window.getComputedStyle && window.getComputedStyle(before.parentElement).whiteSpace === 'normal';
            return normal ? normalText(before.nodeValue) === normalText(after.nodeValue) : before.nodeValue === after.nodeValue;
        }
        if (before.nodeType !== 1) return before.nodeValue === after.nodeValue;
        if (!(strict ? before.cloneNode(false).isEqualNode(after.cloneNode(false)) : cleanClasses(before, false).isEqualNode(cleanClasses(after, false))) || before.childNodes.length !== after.childNodes.length) return false;
        for (var i = 0; i < before.childNodes.length; i += 1) if (!sameNormalNode(before.childNodes[i], after.childNodes[i], strict)) return false;
        return true;
    }
    function sameNormalContents(element, incoming) {
        var before = staticNodes(element.childNodes), after = staticNodes(incoming);
        return !!(before && after && before.length === 1 && after.length === 1 && before[0].tagName === 'DIV' && after[0].tagName === 'DIV' && sameNormalNode(before[0], after[0]));
    }
    function copyNativeClasses(before, after) {
        if (before.nodeType !== 1) return;
        // Comparison already proved that only our three decorative classes differ.
        // Follow the actual native class state; retaining nodes must not retain an obsolete hidden-title state.
        var nativeClass = after.getAttribute('class');
        if (before.getAttribute('class') !== nativeClass) {
            if (nativeClass === null) before.removeAttribute('class');
            else before.setAttribute('class', nativeClass);
        }
        for (var i = 0; i < before.childNodes.length; i += 1) copyNativeClasses(before.childNodes[i], after.childNodes[i]);
    }
    function keepNormalContents(element, incoming) {
        if (!sameNormalContents(element, incoming)) return false;
        copyNativeClasses(staticNodes(element.childNodes)[0], staticNodes(incoming)[0]);
        return true;
    }
    function parseTemplate(source) {
        var holder = window.document.createElement('template');
        if (!holder.content || typeof source !== 'string') return null;
        holder.innerHTML = source;
        return holder.content;
    }
    function sameShell(outer, incoming, id, home) {
        var fragment = window.document.createElement('template');
        if (!fragment.content) return false;
        Array.prototype.forEach.call(incoming, function(node) { fragment.content.appendChild(node.cloneNode(true)); });
        var selector = '[data-cms-cct-instanceid="' + id + '"]';
        var oldMarkers = outer.querySelectorAll(selector), freshMarkers = fragment.content.querySelectorAll(selector);
        if (oldMarkers.length !== 1 || freshMarkers.length !== 1) return false;
        var old = oldMarkers[0], fresh = freshMarkers[0];
        if (old.getAttribute('data-view') !== 'CCT-View' || fresh.getAttribute('data-view') !== 'CCT-View') return false;
        // Native hydration may already have copied the slot. Never replace new slot content in this comparison.
        if (!fresh.childElementCount && !fresh.textContent.trim()) fresh.innerHTML = old.innerHTML;
        var validate = home ? InitialHome.inertNodes : staticNodes;
        var before = validate(outer.childNodes), after = validate(fragment.content.childNodes);
        return !!(before && after && before.length === after.length && before.every(function(node, index) { return node.isEqualNode(after[index]); }));
    }
    function replaceMethod(object, name, method) {
        var descriptor = Object.getOwnPropertyDescriptor(object, name);
        if (!Object.isExtensible(object) || descriptor && (!descriptor.configurable || !descriptor.writable || descriptor.get || descriptor.set)) return null;
        Object.defineProperty(object, name, {configurable: true, writable: true, value: method});
        return function() {
            var current = Object.getOwnPropertyDescriptor(object, name);
            if (!current || current.value !== method) return;
            if (descriptor) Object.defineProperty(object, name, descriptor);
            else delete object[name];
        };
    }
    function installNoopAppend(collection, expected, skipped) {
        if (!collection || collection.length !== 1 || typeof collection.append !== 'function') return null;
        var append = collection.append;
        return replaceMethod(collection, 'append', function(content) {
            var wanted = expected(), node = wanted && wanted.length === 1 && wanted[0];
            var same = this === collection && arguments.length === 1 && content === wanted && node && node.nodeType === 1 &&
                node.tagName === 'DIV' && node.isConnected && node.parentNode === collection[0] && collection[0].lastElementChild === node;
            for (var next = same && node.nextSibling; next; next = next.nextSibling) {
                if (next.nodeType !== 8 && (next.nodeType !== 3 || next.nodeValue.trim())) same = false;
            }
            if (same) { skipped(); return this; }
            return append.apply(this, arguments);
        });
    }
    function withNoopAppend(collection, expected, skipped, run) {
        var restore = installNoopAppend(collection, expected, skipped);
        try { return run(); } finally { if (restore) restore(); }
    }
    function withStablePageAppend(layout, view, run, home) {
        var query = layout.$, restores = [];
        var restoreQuery = replaceMethod(layout, '$', function(selector) {
            var result = query.apply(this, arguments);
            if (this === layout && arguments.length === 1 && selector === layout.content_element) {
                var restore = installNoopAppend(result, function() { return (home ? layout.nmsInitialHomeLayoutRetained && (view.nmsInitialHomeRetained || view.nmsInitialHomeHeroRetained) : view.nmsInitialStaticPageRetained) && view.$el; }, function() { view.nmsInitialStaticAppendRetained = true; });
                if (restore) restores.push(restore);
            }
            return result;
        });
        function restore() { restores.forEach(function(fn) { fn(); }); if (restoreQuery) restoreQuery(); }
        try {
            var result = run();
            if (result && typeof result.always === 'function') result.always(function() { restore(); });
            else restore();
            return result;
        } catch (error) { restore(); throw error; }
    }
    function homeRoute(includeBuyFlu) {
        var host = window.location.hostname;
        return window.location.pathname === '/' && (['nmsincusa.com', 'www.nmsincusa.com', 'sca-sandbox.ethanablatt.com'].indexOf(host) >= 0 ||
            includeBuyFlu === true && ['buyflushots.nmsincusa.com', 'buyflu-sandbox.ethanablatt.com'].indexOf(host) >= 0);
    }
    function canonicalStyles(root) {
        var copy = root.cloneNode(true), styles = copy.querySelectorAll('style');
        for (var i = 0; i < styles.length; i += 1) {
            if (typeof window.CSSStyleSheet !== 'function') return null;
            var sheet;
            try {
                sheet = new window.CSSStyleSheet();
                if (typeof sheet.replaceSync !== 'function') return null;
                sheet.replaceSync(styles[i].textContent);
            } catch (error) { return null; }
            // Reject imports, rejected/unknown rules and empty parses; those stay native.
            if (!sheet.cssRules.length || /@import/i.test(styles[i].textContent)) return null;
            styles[i].textContent = Array.prototype.map.call(sheet.cssRules, function(rule) { return rule.cssText; }).join('\n');
        }
        return copy;
    }
    function sameHomeCmsContents(element, incoming) {
        if (!InitialHome.inertNodes(element.childNodes) || !InitialHome.inertNodes(incoming)) return false;
        var before = element.cloneNode(false), after = element.cloneNode(false);
        Array.prototype.forEach.call(element.childNodes, function(node) { before.appendChild(node.cloneNode(true)); });
        Array.prototype.forEach.call(incoming, function(node) { after.appendChild(node.cloneNode(true)); });
        before = canonicalStyles(before); after = canonicalStyles(after);
        var oldNodes = before && InitialHome.inertNodes(before.childNodes), newNodes = after && InitialHome.inertNodes(after.childNodes);
        return !!(oldNodes && newNodes && oldNodes.length === newNodes.length && oldNodes.every(function(node, index) { return sameNormalNode(node, newNodes[index], true); }));
    }
    function hydrateCms(page, child, placeholder, count, external, nativeChild, args, home) {
        var html = child && child.innerCustomContentType, id = html && html.instanceId, area = placeholder && placeholder[0];
        if (!(html instanceof CmsHtmlView) || !/^CMS_HTML-[0-9]+$/.test(id || '') || !(home ? page.nmsInitialHomeRetained || page.nmsInitialHomeHeroRetained : page.nmsInitialStaticPageRetained) ||
                (home ? page.nmsConnectedHomeCmsAttempted : page.nmsInitialStaticCmsHydrationAttempted) || count !== 1 || external !== true || !area ||
                !(home ? homeRoute() : staticRoute(window.document)) || !page.el.contains(area) || !area.isConnected || area.getAttribute('data-cms-area') !== (home ? 'home-main-slider' : areaName) || area.childElementCount !== 1) {
            return nativeChild.apply(page, args);
        }
        if (home) {
            if (id !== 'CMS_HTML-1') return nativeChild.apply(page, args);
            page.nmsConnectedHomeCmsAttempted = true;
        } else page.nmsInitialStaticCmsHydrationAttempted = true;
        var markers = area.querySelectorAll('[data-cms-cct-instanceid="' + id + '"]');
        var marker = markers.length === 1 && markers[0], outer = marker && marker.parentElement, inner = marker && marker.firstElementChild;
        var htmlFragment, shellFragment;
        try {
            htmlFragment = parseTemplate(html.compileTemplate());
            shellFragment = parseTemplate(child.compileTemplate());
        } catch (error) { return nativeChild.apply(page, args); }
        if (!marker || marker.childElementCount !== 1 || !outer || outer.parentElement !== area || !inner || !htmlFragment || !shellFragment ||
                !(home ? sameHomeCmsContents(inner, htmlFragment.childNodes) : sameNormalContents(inner, htmlFragment.childNodes)) || !outer.cloneNode(false).isEqualNode(child.el.cloneNode(false)) ||
                !sameShell(outer, shellFragment.childNodes, id, home) || typeof child.setElement !== 'function' || typeof html.setElement !== 'function' ||
                typeof child._render !== 'function' || typeof html._render !== 'function' || typeof child._renderChildViewInstance !== 'function') return nativeChild.apply(page, args);
        var originalOuter = child.el, originalInner = html.el, restores = [];
        var nativeRender = child._render, nativeHtml = html._render, nativeInner = child._renderChildViewInstance;
        function skipped() { page.nmsInitialStaticCmsAppendSkips = (page.nmsInitialStaticCmsAppendSkips || 0) + 1; }
        function restoreMethods() { restores.reverse().forEach(function(fn) { fn(); }); }
        try {
            var r = replaceMethod(child, '_render', function() {
                return InitialHome.renderKeepingIdenticalContent(this, nativeRender, arguments, function(element, incoming) { return sameShell(element, incoming, id, home); }, 'nmsInitialStaticCmsShellRetained');
            });
            if (!r) throw new Error('Unmodifiable container render');
            restores.push(r);
            r = replaceMethod(html, '_render', function() {
                return InitialHome.renderKeepingIdenticalContent(this, nativeHtml, arguments, home ? sameHomeCmsContents : keepNormalContents, 'nmsInitialStaticCmsHtmlRetained');
            });
            if (!r) throw new Error('Unmodifiable HTML render');
            restores.push(r);
            r = replaceMethod(child, '_renderChildViewInstance', function(view, slot) {
                var self = this, callArgs = arguments;
                return view === html ? withNoopAppend(slot, function() { return html.$el; }, skipped, function() { return nativeInner.apply(self, callArgs); }) : nativeInner.apply(self, callArgs);
            });
            if (!r) throw new Error('Unmodifiable child render');
            restores.push(r);
            child.setElement(outer);
            html.setElement(inner);
            // The server-only #cms wrapper is not part of the native HTML view.
            // Keep the connected node, with the native view's actual shallow attributes.
            if (home && inner.id === 'cms' && !originalInner.hasAttribute('id')) inner.removeAttribute('id');
        } catch (error) {
            restoreMethods();
            if (child.el !== originalOuter) child.setElement(originalOuter);
            if (html.el !== originalInner) html.setElement(originalInner);
            return nativeChild.apply(page, args);
        }
        if (home) page.nmsConnectedHomeCmsActive = true;
        try {
            return withNoopAppend(placeholder, function() { return child.$el; }, skipped, function() { return nativeChild.apply(page, args); });
        } finally {
            page.nmsInitialStaticCmsRetained = !!(child.nmsInitialStaticCmsShellRetained && html.nmsInitialStaticCmsHtmlRetained);
            if (home) {
                page.nmsConnectedHomeCmsActive = false;
                page.nmsConnectedHomeCmsRetained = page.nmsInitialStaticCmsRetained;
            }
            restoreMethods();
        }
    }
    function install() {
        if (typeof window === 'undefined' || typeof SC === 'undefined' || !SC.ENVIRONMENT || SC.ENVIRONMENT.jsEnvironment !== 'browser') return;
        if (LandingView.prototype.nmsInitialStaticInstalled) return;
        var nativeRender = LandingView.prototype._render, nativeShow = LandingView.prototype.showContent, nativeChild = LandingView.prototype._renderChildViewInstance;
        LandingView.prototype._render = function() {
            var view = this, app = view.options && view.options.application, layout = app && app.getLayout && app.getLayout();
            var content = layout && layout.el && layout.el.querySelector('#content');
            var allowed = !view.nmsInitialStaticRenderAttempted && eligible(view) && layout && layout.currentView === view && content && layout.el.isConnected &&
                (view.el.isConnected ? view.el.parentElement === content : content.childElementCount === 0);
            view.nmsInitialStaticRenderAttempted = true;
            if (!allowed) return nativeRender.apply(view, arguments);
            return InitialHome.renderKeepingIdenticalContent(view, nativeRender, arguments, sameStaticPageContent, 'nmsInitialStaticPageRetained');
        };
        LandingView.prototype.showContent = function() {
            var view = this, app = view.options && view.options.application, layout = app && app.getLayout && app.getLayout();
            var allowed = !view.nmsInitialStaticShowAttempted && eligible(view) && !view.getHeaderView && !view.getFooterView && layout && !layout.currentView &&
                layout.el && layout.el.isConnected && view.el.isConnected && layout.getDOMContentElement && layout.getDOMContentElement() === view.el;
            view.nmsInitialStaticShowAttempted = true;
            if (!allowed) return nativeShow.apply(view, arguments);
            var render = layout.render, consumed = false, restoreRender;
            restoreRender = replaceMethod(layout, 'render', function() {
                if (consumed) return render.apply(this, arguments);
                consumed = true; restoreRender();
                if (this !== layout || !eligible(view)) return render.apply(this, arguments);
                return InitialHome.renderKeepingIdenticalContent(layout, render, arguments, function(element, incoming) { return InitialHome.sameInitialLayout(element, incoming, view); }, 'nmsInitialStaticLayoutRetained');
            });
            if (!restoreRender) return nativeShow.apply(view, arguments);
            var showArgs = arguments;
            return withStablePageAppend(layout, view, function() {
                try {
                    var result = nativeShow.apply(view, showArgs);
                    if (result && typeof result.always === 'function') result.always(function() { restoreRender(); });
                    else restoreRender();
                    return result;
                } catch (error) { restoreRender(); throw error; }
            });
        };
        if (typeof nativeChild === 'function') LandingView.prototype._renderChildViewInstance = function(child, placeholder, count, external) {
            return hydrateCms(this, child, placeholder, count, external, nativeChild, arguments);
        };
        LandingView.prototype.nmsInitialStaticInstalled = true;
        if (HomeView && !HomeView.prototype.nmsConnectedHomeInstalled) {
            var nativeHomeShow = HomeView.prototype.showContent, nativeHomeChild = HomeView.prototype._renderChildViewInstance;
            HomeView.prototype.showContent = function() {
                var view = this, app = view.options && view.options.application, layout = app && app.getLayout && app.getLayout(), args = arguments;
                if (!homeRoute(true) || view.nmsConnectedHomeShowAttempted || !layout || layout.currentView || SC.isRehydrating !== true) return nativeHomeShow.apply(view, args);
                view.nmsConnectedHomeShowAttempted = true;
                return withStablePageAppend(layout, view, function() { return nativeHomeShow.apply(view, args); }, true);
            };
            if (typeof nativeHomeChild === 'function') HomeView.prototype._renderChildViewInstance = function(child, placeholder, count, external) {
                return hydrateCms(this, child, placeholder, count, external, nativeHomeChild, arguments, true);
            };
            HomeView.prototype.nmsConnectedHomeInstalled = true;
        }
    }
    return {mountToApp: install, sameStaticPageContent: sameStaticPageContent, sameNormalContents: sameNormalContents, sameHomeCmsContents: sameHomeCmsContents};
});
